import { LogicNodeDefinition } from '../LogicNodeDefinition';

export const DiodeNode: LogicNodeDefinition = {
  type: 'DIODE',
  createDefaultState: () => null,
  process: (input) => input,
};
